import Analytics from 'analytics';
import googleAnalytics from '@analytics/google-analytics';
import FacebookPixel from './facebookPixel';
import TikTokPixel from './tiktokPixel';

const TRACKING_ID_STRING = process.env.NEXT_PUBLIC_GA_TRACKING_ID || '';

if (!TRACKING_ID_STRING) {
  console.warn('Google Analytics Tracking ID is not defined. Analytics will not be initialized.');
}

const TRACKING_IDS = TRACKING_ID_STRING.split(',')
  .map((id) => id.trim())
  .filter((id) => id !== '');

const FACEBOOK_PIXEL_ID = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_KEY || '';

if (!FACEBOOK_PIXEL_ID) {
  console.warn('Facebook Pixel ID is not defined. Facebook Pixel will not be initialized.');
}

// TikTok Pixel
const TIKTOK_PIXEL_ID = process.env.NEXT_PUBLIC_TIKTOK_PIXEL_KEY || '';

if (!TIKTOK_PIXEL_ID) {
  console.warn('TikTok Pixel ID is not defined. TikTok Pixel will not be initialized.');
}

const ANALYTICS = Analytics({
  app: 't2c-app',
  plugins: [
    TRACKING_IDS.length > 0 &&
      googleAnalytics({
        measurementIds: TRACKING_IDS,
      }),

    FACEBOOK_PIXEL_ID &&
      FacebookPixel({
        pixelId: FACEBOOK_PIXEL_ID,
        enabled: true,
      }),

    TIKTOK_PIXEL_ID &&
      TikTokPixel({
        pixelId: TIKTOK_PIXEL_ID,
        enabled: true,
      }),
  ].filter(Boolean),
});

export const sendGTMEvent = (eventName: string, properties: Record<string, any>) => {
  try {
    // Track via analytics library, targeting only Google Analytics plugin
    ANALYTICS.track(eventName, properties, { plugins: ['google-analytics'] });
  } catch (error) {
    console.warn('GTM event tracking failed:', error);
  }
};

export default ANALYTICS;
